import React from 'react';
import { HeroVariant24 } from '../components/HeroVariant24';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage24() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1549">
      <Navigation data-id="element-1550" />
      <main data-id="element-1551">
        <HeroVariant24 data-id="element-1552" />
        <WhyUs data-id="element-1553" />
        <Services data-id="element-1554" />
        <FAQ data-id="element-1555" />
        <Testimonials data-id="element-1556" />
        <Consultation data-id="element-1557" />
      </main>
      <Footer data-id="element-1558" />
      <CookieBanner data-id="element-1559" />
      <FloatingContact data-id="element-1560" />
    </div>;
}